<template>
  <div class="collections">
    <div class="page-width">
      <h1>{{ $t('collections') }}</h1>
      <ul>
        <li v-for="(item,index) in collectionsData" @click="goTo(item)" :key="index">
          <a>
            <div class="collection-grid-item__title-wrapper">
              <p>{{item.Name}}</p>
            </div>
            <img src="https://cdn.shopify.com/s/files/1/1384/0387/collections/1_1024x1024_2x_3cb59b1f-5cf5-44fa-ba59-3b3866a1812a_360x.jpg?v=1570206184" alt="">
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: "collections",
  data() {
    return {
      collectionsData: []
    }
  },
  computed: mapState({
    allGroups: state => state.navbar.allGroups
  }),
  watch: {
    allGroups: function(newVal, oldVal) {
      const temp = [];
      newVal.forEach(group => {
        group.Categories.forEach( category => {
        temp.push({...category, group: group.Name.toLowerCase()});
        })
      })
      this.collectionsData = temp
    }
  },
  methods: {
    ...mapMutations('products', ['updateActiveCategory']),
    goTo(category) {
      this.updateActiveCategory(category.ProductCategory_id);
      this.$router.push(`collections/${category.group}`);
    },
  },
  mounted: function() {
    const temp = [];
    this.allGroups.forEach(group => {
      group.Categories.forEach( category => {
        temp.push({...category, group: group.Name.toLowerCase()});
      })
    });
    this.collectionsData = temp;
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/collections.less";
</style>



// WEBPACK FOOTER //
// src/view/collections.vue